
(() => {
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
      } catch (e) {
        console.error('[variant-picker] bad variants JSON', e);
        this.variants = [];
      }
      if (!this.variants.length) return;

      this.form = this.closest('form');
      this.sectionEl = this.closest('.shopify-section') || document;
      this.selects = Array.from(this.querySelectorAll('[data-option-select]'));

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-select], [data-option-radio]')) this.onOptionChange();
      });

      this.markAvailability();
    }

    get selectedOptions() {

      const byPos = [];
      for (const el of this.querySelectorAll('[data-option-select], [data-option-radio]:checked')) {
        const pos = Number(el.dataset.optionPosition) - 1;
        byPos[pos] = el.value;
      }
      return byPos;
    }

    findVariant(options) {
      return this.variants.find((v) => v.options.every((val, i) => val === options[i]));
    }

    onOptionChange() {
      const variant = this.findVariant(this.selectedOptions);
      this.markAvailability();
      this.updateForm(variant);
      this.updatePrice(variant);
      this.updateUrl(variant);
      this.updateGallery(variant);
      window.PubSub.publish(window.EVENTS.variantChange, {
        variant: variant || null,
        sectionId: this.dataset.sectionId,
      });
    }

    updateForm(variant) {
      const idInput = this.form?.querySelector('input[name="id"]');
      if (idInput && variant) idInput.value = variant.id;

      const btn = this.form?.querySelector('button[name="add"], [type="submit"]');
      const label = btn?.querySelector('[data-atc-text]') || btn;
      if (!btn) return;
      const s = window.themeStrings || {};
      if (!variant) {
        btn.setAttribute('disabled', '');
        if (label) label.textContent = s.unavailable || 'Unavailable';
      } else if (!variant.available) {
        btn.setAttribute('disabled', '');
        if (label) label.textContent = s.soldOut || 'Sold out';
      } else {
        btn.removeAttribute('disabled');
        if (label) label.textContent = s.addToCart || 'Add to cart';
      }
    }

    updatePrice(variant) {
      const box = this.sectionEl.querySelector('[data-price-container]');
      if (!box || !variant) return;
      const money = window.ThemeUtils.formatMoney;
      let html = '';
      if (variant.compare_at_price > variant.price) {
        html += `<s>${money(variant.compare_at_price)}</s> `;
      }
      html += `<span>${money(variant.price)}</span>`;
      box.innerHTML = html;
    }

    updateUrl(variant) {
      if (!variant || !this.dataset.productUrl) return;
      window.history.replaceState({}, '', `${this.dataset.productUrl}?variant=${variant.id}`);
    }

    updateGallery(variant) {
      const mediaId = variant?.featured_media?.id;
      if (!mediaId) return;
      const slider = this.sectionEl.querySelector('embla-slider[data-product-gallery]');
      const slides = slider ? Array.from(slider.querySelectorAll('.embla__slide')) : [];
      const idx = slides.findIndex((s) => Number(s.dataset.mediaId) === Number(mediaId));
      if (idx >= 0) slider.embla?.scrollTo(idx);
    }

    markAvailability() {
      const current = this.selectedOptions;
      const soldOutSuffix = ` — ${(window.themeStrings?.soldOut || 'sold out').toLowerCase()}`;

      this.selects.forEach((select) => {
        const pos = Number(select.dataset.optionPosition) - 1;
        Array.from(select.options).forEach((opt) => {
          const probe = [...current];
          probe[pos] = opt.value;
          const match = this.variants.find((v) => v.options.every((val, i) => val === probe[i]));
          opt.disabled = !match;
          const base = opt.dataset.baseLabel || opt.textContent.replace(soldOutSuffix, '').trim();
          opt.dataset.baseLabel = base;
          opt.textContent = match && !match.available ? base + soldOutSuffix : base;
        });
      });
    }
  }

  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);
})();
